export default "__VITE_ASSET__Cv9K5P8I__"